import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { slot: "content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "actions" }

import { IonAccordion, IonAccordionGroup, IonButton, IonCard, IonCardHeader, IonCardSubtitle, IonCardTitle, IonChip, IonIcon, IonItem, IonItemDivider, IonLabel, IonReorder, IonToggle, alertController } from '@ionic/vue';
import { computed, onMounted, ref } from 'vue';
import { archiveOutline, checkmarkDoneCircleOutline, closeCircleOutline, globeOutline, pulseOutline, sendOutline, shirtOutline, storefrontOutline } from 'ionicons/icons';
import { useRouter } from 'vue-router';
import { translate } from '@hotwax/dxp-components';
import { RuleService } from '@/services/RuleService';
import { useStore } from 'vuex';
import { showToast } from '@/utils';
import logger from '@/logger';
import emitter from '@/event-bus';


export default /*@__PURE__*/_defineComponent({
  __name: 'RuleItem',
  props: ["rule", "ruleIndex"],
  setup(__props) {

const router = useRouter();
const store = useStore();

const props = __props
const total = computed(() => store.getters["rule/getTotalRulesCount"])
const configFacilities = computed(() => store.getters["util/getConfigFacilities"])
const facilityGroups = computed(() => store.getters["util/getFacilityGroups"])
const isReorderActive = computed(() => store.getters["rule/isReorderActive"]);
const selectedSegment = computed(() => store.getters["util/getSelectedSegment"])

const selectedPage = ref({
  path: '',
  name: ''
}) as any;

onMounted(() => {
  selectedPage.value.path = router.currentRoute.value.path
  selectedPage.value.name = router.currentRoute.value.name
})

async function editThreshold() {
  const alert = await alertController.create({
    header: translate("Edit threshold"),
    inputs: [{
      name: "threshold",
      placeholder: translate("Threshold"),
      type: "number",
      value: props.rule.ruleActions?.length ? props.rule.ruleActions[0].fieldValue : 0,
      min: 0,
      attributes: {
        // Added check to not allow mainly .(period) and other special characters to be entered in the alert input
        onkeydown: ($event: any) => {
          if(/[`!@#$%^&*()_+\-=\\|,.<>?~^e]/.test($event.key) && event.key !== 'Backspace') $event.preventDefault();
        }
      }
    }],
    buttons: [{
      text: translate('Cancel'),
      role: "cancel"
    },
    {
      text: translate('Update'),
      handler: async(data) => {
        if(!data.threshold || data.threshold < 0) {
          showToast(translate("Threshold should be greater than or equal to 0."));
          return false;
        }

        if(data.threshold === props.rule.ruleActions[0].fieldValue) return;

        emitter.emit("presentLoader");

        const rule = JSON.parse(JSON.stringify(props.rule))

        if(!rule.ruleActions?.length) {
          rule.ruleActions = [{
            "ruleId": props.rule.ruleId,
            "actionTypeEnumId": "ATP_SAFETY_STOCK",
            "fieldName": "facility-safety-stock",
            "fieldValue": data.threshold
          }]
        } else {
          rule.ruleActions[0].fieldValue = data.threshold
        }

        try {
          await RuleService.updateRule(rule, props.rule.ruleId)
          await store.dispatch('rule/updateRuleData', { rule })
          showToast(translate("Threshold updated successfully."))
          alertController.dismiss()
        } catch(err: any) {
          showToast(translate("Failed to update threshold."))
          logger.error(err);
        }
        emitter.emit("dismissLoader");
      }
    }]
  })

  await alert.present()
}

async function editSafetyStock() {
  const alert = await alertController.create({
    header: translate("Edit safety stock"),
    inputs: [{
      name: "safetyStock",
      placeholder: translate("Safety stock"),
      type: "number",
      value: props.rule.ruleActions?.length ? props.rule.ruleActions[0].fieldValue : 0,
      min: 0,
      attributes: {
        // Added check to not allow mainly .(period) and other special characters to be entered in the alert input
        onkeydown: ($event: any) => {
          if(/[`!@#$%^&*()_+\-=\\|,.<>?~e]/.test($event.key) && event.key !== 'Backspace') $event.preventDefault();
        }
      }
    }],
    buttons: [{
      text: translate('Cancel'),
      role: "cancel"
    },
    {
      text: translate('Update'),
      handler: async (data: any) => {
        if(!data.safetyStock || data.safetyStock < 0) {
          showToast(translate("Safety stock should be greater than or equal to 0."));
          return false;
        }

        if(data.safetyStock === props.rule.ruleActions[0].fieldValue) return;

        emitter.emit("presentLoader");

        const rule = JSON.parse(JSON.stringify(props.rule))

        if(!rule.ruleActions?.length) {
          rule.ruleActions = [{
            "ruleId": props.rule.ruleId,
            "actionTypeEnumId": "ATP_SAFETY_STOCK",
            "fieldName": "facility-safety-stock",
            "fieldValue": data.safetyStock
          }]
        } else {
          rule.ruleActions[0].fieldValue = data.safetyStock
        }

        try {
          await RuleService.updateRule(rule, props.rule.ruleId)
          await store.dispatch('rule/updateRuleData', { rule })
          showToast(translate("Safety stock updated successfully."))
          alertController.dismiss()
        } catch(err: any) {
          showToast(translate("Failed to update safety stock."))
          logger.error(err);
        }
        emitter.emit("dismissLoader");
      }
    }]
  })

  await alert.present()
}

function getRuleConditionOperator(conditionTypeEnumId: string, fieldName?: string, operator? : string) {
  if(fieldName && operator) {
    const condition = props.rule.ruleConditions.find((condition: any) => condition.conditionTypeEnumId === conditionTypeEnumId && condition.fieldName === fieldName && condition.operator === operator)
    return condition?.joinOperator || "";
  }
  return ""
}

function getRuleConditions(conditionTypeEnumId: string, fieldName?: string, operator? : string) {
  if(!props.rule.ruleConditions) return;

  if(fieldName && operator) {
    const condition = props.rule.ruleConditions.find((condition: any) => condition.conditionTypeEnumId === conditionTypeEnumId && condition.fieldName === fieldName && condition.operator === operator)
    if(condition && conditionTypeEnumId === 'ENTCT_ATP_FAC_GROUPS') {
      if(condition.fieldValue === "ALL") return translate("All facility groups selected");

      let facilityGroupIds = condition?.fieldValue.split(",")
        facilityGroupIds = facilityGroupIds.map((id: string) => {
          let group = facilityGroups.value.find((group: any) => group.facilityGroupId === id)
          return group?.facilityGroupName ? group.facilityGroupName : id
        })
        return facilityGroupIds.join(", ")
    } else {
      return condition?.fieldValue?.split(",").join(", ")
    }
  } else {
    const condition = props.rule.ruleConditions.find((condition: any) => condition.conditionTypeEnumId === conditionTypeEnumId)

    if(condition && condition.fieldValue) {
      if(condition.fieldValue === "ALL") return translate("All channels selected");

      let facilities = condition?.fieldValue.split(",")
      facilities = facilities.map((id: string) => {
        let facility = configFacilities.value.find((facility: any) => facility.facilityId === id)
        return facility?.facilityName ? facility.facilityName : id
      })
      return facilities.join(", ")
    }
  }
}

async function archiveRule() {
  const alert = await alertController
    .create({
      header: translate('Archive rule'),
      message: translate('Are you sure you want to archive this rule?'),
      buttons: [{
        text: translate('No'),
        role: 'cancel'
      }, {
        text: translate('Yes'),
        handler: async () => {
          emitter.emit("presentLoader");
          const rule = JSON.parse(JSON.stringify(props.rule))
          rule.statusId = "ATP_RULE_ARCHIVED"

          try {
            await RuleService.updateRule(rule, props.rule.ruleId)
            await store.dispatch('rule/fetchRules', { ruleGroupId: props.rule.ruleGroupId })
            showToast(translate("Rule archived successfully."))
            alertController.dismiss()
          } catch(err: any) {
            showToast(translate("Failed to update threhold."))
            logger.error(err);
          }
          emitter.emit("dismissLoader");
        }
      }]
    });
  return alert.present();
}

function isRuleConditionAvailable(conditionTypeEnumId: string, fieldName?: string, operator? : string) {
  if(fieldName) return props.rule.ruleConditions?.find((condition: any) => condition.conditionTypeEnumId === conditionTypeEnumId && condition.fieldName === fieldName && condition.operator === operator)?.fieldValue
  else return props.rule.ruleConditions?.find((condition: any) => condition.conditionTypeEnumId === conditionTypeEnumId)?.fieldValue
}

function areProductFiltersSelected() {
  return props.rule.ruleConditions.some((condition: any) => condition.conditionTypeEnumId === "ENTCT_ATP_FILTER" && condition.fieldValue);
}

async function updateRulePickup(event: any) {
  event.stopImmediatePropagation();
  const isChecked = !event.target.checked;
  
  emitter.emit("presentLoader");
  try {
    const rule = JSON.parse(JSON.stringify(props.rule))
    rule.ruleActions.map((action: any) => {
      if(action.actionTypeEnumId === "ATP_ALLOW_PICKUP") action.fieldValue = isChecked ? "Y" : "N"
    })

    await RuleService.updateRule(rule, props.rule.ruleId)
    showToast(translate("Rule pickup updated successfully."))
    await store.dispatch('rule/updateRuleData', { rule })
    event.target.checked = isChecked
  } catch(err) {
    logger.error(err)
    showToast(translate("Failed to update rule pickup."))
  }
  emitter.emit("dismissLoader");
}

async function updateRuleShipping(event: any) {
  event.stopImmediatePropagation();
  const isChecked = !event.target.checked;

  emitter.emit("presentLoader");
  try {
    const rule = JSON.parse(JSON.stringify(props.rule))
    rule.ruleActions.map((action: any) => {
      if(action.actionTypeEnumId === "ATP_ALLOW_BROKERING") action.fieldValue = isChecked ? "Y" : "N"
    })

    await RuleService.updateRule(rule, props.rule.ruleId)
    showToast(translate("Rule shipping updated successfully."))
    await store.dispatch('rule/updateRuleData', { rule })
    event.target.checked = isChecked
  } catch(err) {
    logger.error(err)
    showToast(translate("Failed to update rule brokering."))
  }
  emitter.emit("dismissLoader");
}

function editRule() {
  let path = ""
  if(selectedPage.value.path === "/threshold") {
    path = `update-threshold/${props.rule.ruleId}`
  } else if(selectedPage.value.path === "/safety-stock") {
    path = `update-safety-stock/${props.rule.ruleId}`
  } else if(selectedPage.value.path === "/store-pickup") {
    path = `update-store-pickup/${props.rule.ruleId}`
  } else if(selectedPage.value.path === "/shipping") {
    path = `update-shipping/${props.rule.ruleId}`
  }

  if(selectedSegment.value) {
    router.push({ path, query: { groupTypeEnumId: selectedSegment.value } });
  } else {
    router.push(path)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonAccordionGroup), { value: isReorderActive.value }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonAccordion), { value: "false" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCardHeader), {
                slot: "header",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($event.stopImmediatePropagation()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_unref(IonCardSubtitle), { class: "overline" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.rule.ruleId), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCardTitle), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.rule.ruleName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCardSubtitle), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.ruleIndex+1) + "/" + _toDisplayString(total.value), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  (isReorderActive.value)
                    ? (_openBlock(), _createBlock(_unref(IonItem), {
                        key: 0,
                        lines: "none"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonReorder), { slot: "end" })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_1, [
                (selectedPage.value.path === '/threshold')
                  ? (_openBlock(), _createBlock(_unref(IonItem), {
                      key: 0,
                      lines: "full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), {
                          slot: "start",
                          icon: _unref(globeOutline)
                        }, null, 8, ["icon"]),
                        _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(translate)(selectedPage.value.name)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonChip), {
                          slot: "end",
                          outline: "",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (editThreshold()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.rule.ruleActions?.length ? __props.rule.ruleActions[0]?.fieldValue : '-'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (selectedPage.value.path === '/safety-stock')
                    ? (_openBlock(), _createBlock(_unref(IonItem), {
                        key: 1,
                        lines: "full"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "start",
                            icon: _unref(pulseOutline)
                          }, null, 8, ["icon"]),
                          _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)(selectedPage.value.name)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonChip), {
                            slot: "end",
                            outline: "",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (editSafetyStock()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(__props.rule.ruleActions?.length ? __props.rule.ruleActions[0].fieldValue : '-'), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (selectedPage.value.path === '/store-pickup')
                      ? (_openBlock(), _createBlock(_unref(IonItem), {
                          key: 2,
                          lines: "full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonIcon), {
                              slot: "start",
                              icon: _unref(storefrontOutline)
                            }, null, 8, ["icon"]),
                            _createVNode(_unref(IonToggle), {
                              checked: props.rule.ruleActions[0].fieldValue === 'Y' ? true : false,
                              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (updateRulePickup($event)), ["prevent"]))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)(selectedPage.value.name)), 1)
                              ]),
                              _: 1
                            }, 8, ["checked"])
                          ]),
                          _: 1
                        }))
                      : (selectedPage.value.path === '/shipping')
                        ? (_openBlock(), _createBlock(_unref(IonItem), {
                            key: 3,
                            lines: "full"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                icon: _unref(sendOutline)
                              }, null, 8, ["icon"]),
                              _createVNode(_unref(IonToggle), {
                                checked: props.rule.ruleActions[0].fieldValue === 'Y' ? true : false,
                                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (updateRuleShipping($event)), ["prevent"]))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)(selectedPage.value.name)), 1)
                                ]),
                                _: 1
                              }, 8, ["checked"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                (selectedPage.value.path === '/threshold' || selectedSegment.value === 'RG_PICKUP_CHANNEL' || selectedSegment.value === 'RG_SHIPPING_CHANNEL')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createVNode(_unref(IonItemDivider), { color: "light" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("Channels")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (isRuleConditionAvailable('ENTCT_ATP_FACILITIES'))
                        ? (_openBlock(), _createBlock(_unref(IonItem), {
                            key: 0,
                            lines: "full"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                icon: _unref(checkmarkDoneCircleOutline)
                              }, null, 8, ["icon"]),
                              _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(getRuleConditions("ENTCT_ATP_FACILITIES")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                      _createVNode(_unref(IonItemDivider), { color: "light" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("Facilities")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (isRuleConditionAvailable('ENTCT_ATP_FAC_GROUPS', 'facilityGroupId', 'in'))
                        ? (_openBlock(), _createBlock(_unref(IonItem), { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                icon: _unref(checkmarkDoneCircleOutline)
                              }, null, 8, ["icon"]),
                              _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(getRuleConditions("ENTCT_ATP_FAC_GROUPS", "facilityGroupId", "in")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (isRuleConditionAvailable('ENTCT_ATP_FAC_GROUPS', 'facilityGroupId', 'not-in'))
                        ? (_openBlock(), _createBlock(_unref(IonItem), {
                            key: 1,
                            lines: "full"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                icon: _unref(closeCircleOutline)
                              }, null, 8, ["icon"]),
                              _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(getRuleConditions("ENTCT_ATP_FAC_GROUPS", "facilityGroupId", "not-in")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64)),
                (areProductFiltersSelected())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      (isRuleConditionAvailable('ENTCT_ATP_FILTER', 'tags', 'contains') || isRuleConditionAvailable('ENTCT_ATP_FILTER', 'tags', 'not-contains'))
                        ? (_openBlock(), _createBlock(_unref(IonItemDivider), {
                            key: 0,
                            color: "light"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonLabel), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("Product tags")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (isRuleConditionAvailable('ENTCT_ATP_FILTER', 'tags', 'contains'))
                        ? (_openBlock(), _createBlock(_unref(IonItem), {
                            key: 1,
                            lines: isRuleConditionAvailable('ENTCT_ATP_FILTER', 'tags', 'not-contains') ? '' : 'full'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                icon: _unref(checkmarkDoneCircleOutline)
                              }, null, 8, ["icon"]),
                              _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(getRuleConditions("ENTCT_ATP_FILTER", "tags", "contains")) + " ", 1),
                                  (getRuleConditionOperator('ENTCT_ATP_FILTER', 'tags', 'contains'))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString("Operator: ") + _toDisplayString(getRuleConditionOperator("ENTCT_ATP_FILTER", "tags", "contains")), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["lines"]))
                        : _createCommentVNode("", true),
                      (isRuleConditionAvailable('ENTCT_ATP_FILTER', 'tags', 'not-contains'))
                        ? (_openBlock(), _createBlock(_unref(IonItem), {
                            key: 2,
                            lines: "full"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                icon: _unref(closeCircleOutline)
                              }, null, 8, ["icon"]),
                              _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(getRuleConditions("ENTCT_ATP_FILTER", "tags", "not-contains")) + " ", 1),
                                  (getRuleConditionOperator('ENTCT_ATP_FILTER', 'tags', 'not-contains'))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString("Operator: ") + _toDisplayString(getRuleConditionOperator("ENTCT_ATP_FILTER", "tags", "not-contains")), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (isRuleConditionAvailable('ENTCT_ATP_FILTER', 'productFeatures', 'contains') || isRuleConditionAvailable('ENTCT_ATP_FILTER', 'productFeatures', 'not-contains'))
                        ? (_openBlock(), _createBlock(_unref(IonItemDivider), {
                            key: 3,
                            color: "light"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonLabel), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(translate)("Product features")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (isRuleConditionAvailable('ENTCT_ATP_FILTER', 'productFeatures', 'contains'))
                        ? (_openBlock(), _createBlock(_unref(IonItem), {
                            key: 4,
                            lines: isRuleConditionAvailable('ENTCT_ATP_FILTER', 'productFeatures', 'not-contains') ? '' : 'full'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                icon: _unref(checkmarkDoneCircleOutline)
                              }, null, 8, ["icon"]),
                              _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(getRuleConditions("ENTCT_ATP_FILTER", "productFeatures", "contains")) + " ", 1),
                                  (getRuleConditionOperator('ENTCT_ATP_FILTER', 'productFeatures', 'contains'))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString("Operator: ") + _toDisplayString(getRuleConditionOperator("ENTCT_ATP_FILTER", "productFeatures", "contains")), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["lines"]))
                        : _createCommentVNode("", true),
                      (isRuleConditionAvailable('ENTCT_ATP_FILTER', 'productFeatures', 'not-contains'))
                        ? (_openBlock(), _createBlock(_unref(IonItem), {
                            key: 5,
                            lines: "full"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                icon: _unref(closeCircleOutline)
                              }, null, 8, ["icon"]),
                              _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(getRuleConditions("ENTCT_ATP_FILTER", "productFeatures", "not-contains")) + " ", 1),
                                  (getRuleConditionOperator('ENTCT_ATP_FILTER', 'productFeatures', 'not-contains'))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString("Operator: ") + _toDisplayString(getRuleConditionOperator("ENTCT_ATP_FILTER", "productFeatures", "not-contains")), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                      _createVNode(_unref(IonItemDivider), { color: "light" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("Products")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), { lines: "full" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "start",
                            icon: _unref(shirtOutline)
                          }, null, 8, ["icon"]),
                          _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translate)("All products selected.")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64)),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(IonButton), {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (editRule())),
                    fill: "clear"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(translate)("Edit rule")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonButton), {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (archiveRule())),
                    color: "medium",
                    fill: "clear",
                    slot: "end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        icon: _unref(archiveOutline),
                        slot: "icon-only"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }))
}
}

})